import { FunctionComponent } from 'react';
import BaseStructure, { BaseStructureProps } from './BaseStructure';

export const SightLayout: FunctionComponent<BaseStructureProps> = props => <BaseStructure {...props} />;

export default SightLayout;
